module.exports = __webpack_public_path__ + "img/contact_1.169d16e1.png";